<div class="a00240 a00240--{{ modifier }}">
    <div *ngIf="modifier == 'a'" class="grey-divider"></div>
    <div *ngIf="modifier == 'b'" class="black-divider"></div>
</div>
